import { Expevisit } from "../../app/DTOs//Expevisit.component";

export class NextDeparture {
    private id: number;
    private lineId: string;
    private name: string;
    private expevisit: Expevisit;
    private destiny: string;
    private color: string;
    private time: string;
    private timeValue: number;
    private estimationTime: string;

    constructor( id: number, lineId: string, name: string, expevisit: Expevisit, destiny: string, color: string, time: string, timeValue: number ) {
        this.id = id;
        this.lineId = lineId;
        this.name = name;
        this.expevisit = expevisit;
        this.destiny = destiny;
        this.color = color;
        this.time = time;
        this.timeValue = timeValue;
    }

    public setId (id: number) { this.id = id; }
    public getId () { return this.id; }
    
    public setLineId (lineId: string) { this.lineId = lineId; }
    public getLineId () { return this.lineId; }
    
    public setName (name: string) { this.name = name; }
    public getName () { return this.name; }

    public setExpevisit (expevisit: Expevisit) { this.expevisit = expevisit; }
    public getExpevisit () { return this.expevisit; }
    
    public setDestiny (destiny: string) { this.destiny = destiny; }
    public getDestiny () { return this.destiny; }
    
    public setColor (color: string) { this.color = color; }
    public getColor () { return this.color; }
    
    public setTime (time: string) { this.time = time; }
    public getTime () { return this.time; }
    
    public setTimeValue (timeValue: number) { this.timeValue = timeValue; }
    public getTimeValue () { return this.timeValue; }
    
    public setEstimationTime (estimationTime: string) { this.estimationTime = estimationTime; }
    public getEstimationTime () { return this.estimationTime; }

    public searchForId (idSearched: number) {
        if (idSearched == this.id) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/NextDeparture.component.ts